import { isNumber } from 'lodash';
import React from 'react';

import useStyles from './styles';

interface Props {
    variant?: 'default' | 'danger-contained' | 'danger-outlined';
    icon?: React.ReactNode;
    text: string;
    count?: number;
    compact?: boolean;
    className?: string;
}

const Label: React.FC<Props> = ({ variant = 'default', icon, text, count, compact, className }) => {
    const { classes, cx } = useStyles();
    return (
        <span
            className={cx(
                classes.root,
                {
                    [classes._danger_contained]: variant === 'danger-contained',
                    [classes._danger_outlined]: variant === 'danger-outlined',
                    [classes._default]: variant === 'default',
                    [classes._compact]: compact
                },

                className
            )}
        >
            {icon ? <span className={classes.icon}>{icon}</span> : null}
            {text}
            {isNumber(count) ? <span className={classes.count}>{count}</span> : null}
        </span>
    );
};

export default Label;
